'use strict';

import controller from './controller';
import formTeamModule from './form-team';

const MODULE_NAME = 'daupler.entities.ugSewer';

var app = angular.module(MODULE_NAME, [
	formTeamModule,
]);
app.controller('UgSewerCtrl', controller);

export default MODULE_NAME;
